import { render, staticRenderFns } from "./Journals.vue?vue&type=template&id=ec5209ca&"
import script from "./Journals.vue?vue&type=script&lang=js&"
export * from "./Journals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports